import { useEffect, useState } from 'react'

/**
 * Detects whether the app is running in PWA standalone mode (installed
 * to home screen on Android, "Add to Home Screen" on iOS, or any other
 * `display-mode: standalone` host).
 *
 * Returns `{ isStandalone }`. Updates reactively if the media query
 * changes mid-session (rare but possible when a user installs and the
 * browser flips state without a reload).
 */
export function useStandaloneMode(): { isStandalone: boolean } {
  const [isStandalone, setIsStandalone] = useState(() => {
    if (typeof window === 'undefined') return false
    const mql = window.matchMedia('(display-mode: standalone)')
    const ios = (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    return mql.matches || ios
  })

  useEffect(() => {
    const mql = window.matchMedia('(display-mode: standalone)')
    const ios = (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    const onChange = (e: MediaQueryListEvent) => setIsStandalone(e.matches || ios)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return { isStandalone }
}
